import { render, staticRenderFns } from "./ContractsAccept.vue?vue&type=template&id=c27532f4&"
import script from "./ContractsAccept.vue?vue&type=script&lang=js&"
export * from "./ContractsAccept.vue?vue&type=script&lang=js&"
import style0 from "./ContractsAccept.vue?vue&type=style&index=0&id=c27532f4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports